const KEY = 'couplespace:last-page-id';

export async function getLastPageId(): Promise<string | null> {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  return localStorage.getItem(KEY);
}

export async function setLastPageId(id: string): Promise<void> {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(KEY, id);
  }
}

export async function clearLastPageId(): Promise<void> {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(KEY);
  }
}
